<template>
  <div>
    <v-sheet v-if="loading" :color="'grey lighten-4'" class="pa-3">
      <v-skeleton-loader type="card-heading, table-row-divider">
      </v-skeleton-loader>
    </v-sheet>
    <fragment>
      <page-head
        small
        :back-route-path="'/bankruptcy/bankruptcy-file/'+ mainRequestObjectKey"
        show-back
      >
      </page-head>
      <page-content small>
        <div v-if="isViewMode" class="request-info-root">
          <div v-if="replyMemo.code">
            <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestCode }}</span> {{
              mainRequestDetails.code }}</b>
          </div>
          <div v-if="replyMemo.creationDate">
            <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestDate }}</span> {{
              mainRequestDetails.creationDate | hijriDate }}</b>
          </div>
        </div>

        <!-- request summary  -->
        <div v-if="mainRequestDetails">
          <request-summary :request-info="mainRequestDetails"></request-summary>
        </div>
        <!-- request summary  -->

        <v-form ref="requestFormRef">
          <naj-dynamic-form :custom-component-name="'ReplyMemoForm'" :form-model="replyMemo"
            :required-data="{procedureName: mainRequestDetails.procedureName}" :is-new-mode="isNewMode"
            :is-view-mode="isViewMode"></naj-dynamic-form>
        </v-form>

        <v-row v-if="isNewMode">
          <v-col cols="12" class="text-left">
            <naj-button @click="validateTenSubmit">
              {{ local.common.saveAndSend }}
            </naj-button>
            <naj-confirmation :show-modal="showSendRequestConfirmationModal"
              :title="local.common.confirmationSendRequest"
              :message="local.bankruptcy.subRequests.sendRequestConfirmationMessage" :ok-btn-label="local.common.yes"
              :close-btn-label="local.common.no" @ok="onSubmit"
              @cancel="showSendRequestConfirmationModal = false"></naj-confirmation>
          </v-col>
        </v-row>

        <naj-confirmation :show-modal="showInformationModal" :max-width="750" :is-persistent="true"
          :title="local.bankruptcy.subRequests.successAlertMessage" :close-btn-label="local.common.close"
          @cancel="closeInformationModal">
          <template slot="message-content">
            <v-row>
              <v-col>
                <naj-alert type="success">
                  <template slot="content">
                    {{ local.bankruptcy.subRequests.requestSendSuccessfully }}، {{
                    local.bankruptcy.subRequests.requestCode }} {{ requestCodeResult }}
                  </template>
                </naj-alert>
              </v-col>
            </v-row>
          </template>
        </naj-confirmation>

        <naj-confirmation :show-modal="showValidationSummaryModal" :max-width="1000" :is-persistent="true"
          :title="local.bankruptcy.subRequests.validationSummaryTitle" :close-btn-label="local.common.close" @cancel="() => {
            showValidationSummaryModal = false;
            validationSummaryText='';
          }">
          <template slot="message-content">
            <v-row>
              <v-col>
                <naj-alert type="error">
                  <template slot="content">
                    <div v-html="validationSummaryText" />
                  </template>
                </naj-alert>
              </v-col>
            </v-row>
          </template>
        </naj-confirmation>
      </page-content>
    </fragment>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import { mode } from '@/helpers/enum';
import { resetScroll } from '@/helpers/utils';
import RequestSummary from '../sub-requests/request-summary.vue';
import { toHijriDate } from '@/helpers/utils';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
const { mapActions: mapBankruptcyActions, mapState: mapBankruptcyState } = createNamespacedHelpers('BankruptcyModule');
import { procedureTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  components: { RequestSummary },
  data() {
    return {
      toHijriDate,
      mode,
      showSendRequestConfirmationModal: false,
      loading: false,
      formModel: { attachments: [] },
      selectedAttachment: null,
      deleteModalVisibility: false,
      activeAttachment: null,
      showInformationModal: false,
      requestCodeResult: '',
      showValidationSummaryModal: false,
      validationSummaryText: '',
      mainRequestDetails: {},
      debtorDetails: {},
      replyMemo: {},
      procedureTypeEnum,
    };
  },
  computed: {
    ...mapBankruptcyState([
      'attachmentTypes',
    ]),
    isViewMode() {
      return this.$route.params.replyMemoObjectKey;
    },
    isNewMode() {
      if (this.isViewMode) return false;
      return (!this.$route.params.replyMemoObjectKey);
    },
    bankruptcyProofs() {
      let liquidationProcedures = [procedureTypeEnum.liquidation, procedureTypeEnum.smallDebtorsLiquidation, procedureTypeEnum.administrativeLiquidation];
      if (liquidationProcedures.includes(this.mainRequestDetails.procedureTypeId)) {
        return this.local.bankruptcy.debtorForm.liquidationBankruptcyProofs;
      }
      else {
        return this.local.bankruptcy.debtorForm.bankruptcyProofs;
      }
    },
  },
  watch: {},
  mounted() {
    this.loading = true;
    this.getData();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapBankruptcyActions([
      'mainRequestInquiry',
      'getDebtorsDetails',
      'getAttachmentTypes',
      'getReplyMemo',
      'canIssueReplyMemo',
      'saveReplyMemo',
    ]),
    ...mapActions([
      'uploadAttachment',
    ]),
    getData() {
      this.mainRequestObjectKey = this.$route.params.mainRequestObjectKey;
      this.loading = true;
      const searchQuery = { mainRequestObjectKey: this.mainRequestObjectKey };
      const apiCalls = [
        this.mainRequestInquiry(searchQuery),
        this.getDebtorsDetails(this.mainRequestObjectKey),
        this.getAttachmentTypes(),
      ];

      if (this.isViewMode) {
        apiCalls.push(this.getReplyMemo({
          mainRequestObjectKey: this.mainRequestObjectKey,
          replyMemoObjectKey: this.$route.params.replyMemoObjectKey,
        }));
      }

      Promise.all(apiCalls).then((result) => {
        this.mainRequestDetails = result[0].data;
        this.debtorDetails = result[1].data;
        if (this.isViewMode) {
          this.replyMemo = result[3].data;
        }
      })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      const payload = {
        mainRequestObjectKey: this.mainRequestObjectKey,
        payload: {
          ...this.replyMemo,
          mainRequestObjectKey: this.mainRequestObjectKey,
        },
      };
      if (this.isNewMode) {
        this.saveReplyMemo(payload)
          .then((result) => {
            this.showSendRequestConfirmationModal = false;
            this.requestCodeResult = result.data;
            this.showInformationModal = true;
          })
          .catch((err) => {
            if (err.handled) {
              this.showSendRequestConfirmationModal = false;
              this.showValidationSummaryModal = true;
              this.validationSummaryText = err.message;
            } else {
              this.toaster.error(err.message);
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    closeInformationModal() {
      this.$router.push({ path: '/bankruptcy' });
      this.showInformationModal = false;
    },
    validateTenSubmit() {
      this.$refs.requestFormRef.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.canIssueReplyMemo(this.mainRequestObjectKey)
              .then(() => {
                this.showSendRequestConfirmationModal = true;
              });
          } else {
            resetScroll();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .request-info-root {
    background-color: #faf9f4;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #158e8d;
    margin-bottom: 20px;

    > div {
      min-width: 170px;
      > b {
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-weight: 700;
        margin-bottom: 5px;
        > span {
          margin-right: 0;
          margin-left: 5px;
        }
      }
    }
  }
}
.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.request-reason-label {
  font-size: 20px;
}
.request-reason-text {
  font-size: 15px;
  color: #484952a0;
}
.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

.file-upload-icon {
  cursor: pointer;
}
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  position: relative;
  border: 1px solid #dbdbdb;
}

.attribute-item-row-sub {
  display: flex;
  border: 1px solid #dbdbdb;
  justify-content: space-evenly;
}
.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}
</style>
